import api from "@/api";

const state = () => ({
  data: null,
  sharedLibPromos: null,
});

const actions = {
  async fetch({ commit, dispatch }) {
    const data = await api({
      url: "/123/promotions",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("SET", data.info);
  },
  async fetchSharedLibraryPromotions({ commit, dispatch }) {
    const data = await api({
      url: "/123/products/promotions",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("SET_SHARED_LIB_PROMOTIONS", data.info);
  },
};

const getters = {
  promotions({ data }) {
    if (!data) {
      return;
    }
    return !!data.length;
  },
};

const mutations = {
  CLEAR(state) {
    state.data = [];
  },
  SET(state, promotions) {
    state.data = promotions;
  },
  SET_SHARED_LIB_PROMOTIONS(state, promotions) {
    state.sharedLibPromos = promotions;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
